import { createSlice } from "@reduxjs/toolkit";
import type { IAuth } from "../models/Auth";
import type { IUser } from "../models/User";

const initialState: IAuth = {
  user: null,
  userId: null,
  accessToken: null,
  sessionScope: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authChange: (state, { payload }: { payload?: IAuth }) => {
      if (payload) {
        state.user = payload?.user;
        state.userId = payload?.userId;
        state.accessToken = payload?.accessToken;
        state.sessionScope = payload?.sessionScope;
      } else {
        state.user = null;
        state.userId = null;
        state.accessToken = null;
        state.sessionScope = null;
      }

      return state;
    },
    authMe: (state, { payload }: { payload: IUser }) => {
      state.user = payload;
      state.userId = payload?.id;

      return state;
    },
  },
});

export const authReducer = authSlice.reducer;

export const { authChange, authMe } = authSlice.actions;
